/// <reference path="../../_references.ts"/>

module App.History {
	import Appointment = App.Appointments.Appointment;
	import AppRootScope = App.Administrative.AppRootScope;
	import OfficeService = App.Utils.OfficeService;
	import SelectedAppointment = App.Appointments.SelectedAppointment;
	import ServiceRequest = App.Customer.ServiceRequest;
	import TitleBarService = App.Helpers.TitleBarService;

	export class RecommendationsListController {
		static $inject: string[] = ['$rootScope', '$state' ,'TitleBarService', 'SelectedAppointment', 'HistoryService', 'OfficeService', '$window', '$stateParams'];

		serviceRequestHistory: ServiceRequest[];
		fromOffice: boolean = false;
		addressSearch: boolean = false;

		constructor(
			private $rootScope: AppRootScope,
			private $state: ng.ui.IStateService,
			private TitleBarService: TitleBarService,
			private SelectedAppointment: SelectedAppointment,
			private HistoryService: HistoryService,
			private OfficeService: OfficeService,
			private $window: ng.IWindowService,
			private $stateParams: ng.ui.IStateParamsService,
		) {
			TitleBarService.set('History');

			this.addressSearch = Boolean($state.params.addressId);

			OfficeService.getAppointment()
				.then(response => {
					this.fromOffice = true;
					return response.data;
				})
				.catch(() => SelectedAppointment.getAppointment())
				.then((appt: Appointment) => this.initialize(
					this.addressSearch
						? $state.params.addressId
						: appt.service_request.service_address.id
				));
		}

		initialize(addressId: number) {
			const vm = this;

			vm.$rootScope.app.startAppLoading();

			vm.HistoryService.getServiceRequestRecommendationsByAddress(addressId)
				.then((response) => {
					vm.serviceRequestHistory = response.data;
				}).finally(() => {
					this.$rootScope.app.stopAppLoading();
				});
		}

		goBack() {
			if (!this.fromOffice) {
				this.$window.history.back();
			} else {
				this.$state.go('zipSolutions.history');
			}
		}

		showRecommendations(serviceRequest: ServiceRequest) {
			if(serviceRequest) {
				this.$state.go('zipSolutions.history.recommendations.detail', { id: serviceRequest.id });
			}
		}
	}
}